import React, { useState, useRef } from "react";
import { Box, Button, Spinner, Center } from "@chakra-ui/react";
import Fishbone from "@hophiphip/react-fishbone";
import "../fishbone/index.css";
import html2canvas from "html2canvas";
import { FaFileDownload } from "react-icons/fa";

interface Node {
  name: string;
  children: { name: string }[];
}

function FishboneDiagram({
  props,
  key,
  effect,
}: {
  props: Node[];
  key: number;
  effect: string;
}) {
  const diagramRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const downloadDiagram = async () => {
    if (diagramRef.current) {
      setIsLoading(true); // Start spinner
      try {
        const canvas = await html2canvas(diagramRef.current);
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "fishbone-diagram.png";
        link.click();
      } catch (error) {
        console.error("Error capturing diagram:", error);
      } finally {
        setIsLoading(false); // Stop spinner
      }
    } else {
      console.error("diagramRef is null");
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      <Button
        alignSelf="end"
        m={5}
       size={"sm"}
       leftIcon={<FaFileDownload />}
        colorScheme="blue"
        onClick={downloadDiagram}
        isDisabled={isLoading} // Disable button while loading
      >
        {isLoading ? "Downloading..." : "Download Diagram"}
      </Button>
      {isLoading && (
        <Center mt={4}>
          <Spinner size="lg" color="blue.500" />
        </Center>
      )}
      <Box
        ref={diagramRef} // Reference for capturing the diagram
        bg="white" // Ensure a white background for better visibility
        p={4}
        borderRadius="md"
        boxShadow="md"
        opacity={isLoading ? 0.5 : 1} // Dim diagram while loading
        pointerEvents={isLoading ? "none" : "auto"} // Prevent interaction while loading
      >
        <Fishbone
          items={{
            name: effect,
            children: props,
          }}
          wrapperStyle={{
            height: 500,
            width: "100%",
            marginLeft: "auto",
            padding: 20,
            fontSize: 15,
            borderRadius: 5,
          }}
        />
      </Box>
    </Box>
  );
}

export default FishboneDiagram;
